import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL, absUrl, isCanonicalHost } from "@/lib/site";

const DEFAULT_IMG = `${SITE_URL}/og-card.jpg`;

export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_IMG,
  type = "website",
  keywords,
  jsonLd,
  noindex = false,
}) {
  // Auto-noindex when we're not on the canonical host (preview, staging).
  // Decided once on mount so SSR/initial markup matches the client.
  const [autoNoIndex, setAutoNoIndex] = useState(false);
  useEffect(() => {
    if (!isCanonicalHost()) setAutoNoIndex(true);
  }, []);

  const url = absUrl(path);
  const fullTitle = title.includes("Weight Loss Gurukul")
    ? title
    : `${title} — Weight Loss Gurukul`;
  const ogImage = absUrl(image);
  const shouldNoIndex = noindex || autoNoIndex;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      {shouldNoIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Weight Loss Gurukul" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Weight Loss Gurukul — Ancient Wisdom · Real Transformation" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Structured data */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
